module.exports = __webpack_public_path__ + "static/img/haos-game-lucre-games-logo-black.b87aa20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/haos/haos-game-lucre-games-logo-black.png
// module id = atPT
// module chunks = 0